import React from 'react';
import { colors } from '../../../../theme';
export var Save = function Save(props) {
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.11072 11.2153V16.2159C1.11072 16.7682 1.55843 17.2159 2.11072 17.2159H16.1107C16.663 17.2159 17.1107 16.7682 17.1107 16.2159V11.2153",
    stroke: props.color || colors.PRIMARY,
    strokeWidth: "1.2",
    strokeLinecap: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54389 0.796158C9.30989 0.561534 8.92999 0.561033 8.69536 0.795039L4.87195 4.60838C4.63733 4.84238 4.63683 5.22228 4.87084 5.4569C5.10484 5.69153 5.48474 5.69203 5.71936 5.45802L9.11795 2.06839L12.5076 5.46698C12.7416 5.7016 13.1215 5.7021 13.3561 5.46809C13.5907 5.23409 13.5912 4.85419 13.3572 4.61957L9.54389 0.796158ZM9.70193 14.2161L9.71907 1.22065L8.51907 1.21907L8.50193 14.2145L9.70193 14.2161Z",
    fill: props.color || colors.PRIMARY,
    stroke: props.color || colors.PRIMARY,
    strokeWidth: "0.2"
  }));
};